<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="bg-color-white mx-2 rounded-top my-3 shadow-sm">
          <b-row>
            <b-col cols="12" sm="5" class="custom-border-presence my-1">
              <div class="p-1 pl-4">Nom</div>
            </b-col>
            <b-col cols="7" class="my-1 d-none d-sm-block">
              <div class="p-1">Pouvoirs détenus</div>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col cols="12" sm="5">
        <appMandateName
          :mandate="selectedMandate"
          :presence-mandates="presenceMandates"
          :contact="selectedContact"
        />
      </b-col>

      <b-col cols="12" class="d-block d-sm-none">
        <div class="bg-color-white mx-2 rounded-top my-3 shadow-sm">
          <b-row>
            <b-col cols="7" class="my-1">
              <div class="p-1 pl-4">Pouvoirs détenus</div>
            </b-col>
          </b-row>
        </div>
      </b-col>

      <b-col cols="9" sm="5" class="pr-0">
        <appMandateRepresentant
          :main-mandate="selectedMandate"
          :presence-mandates="presenceMandates"
          :added-by-qr-code="addedByQrCode"
          :contact="selectedContact"
          @qrCodeAddedSuccesfully="addedByQrCode = null"
        />
      </b-col>
      <b-col cols="3" sm="2" class="px-0">
        <div class="text-center">
          <div class="btn bg-color-white shadow-sm mr-3 mr-sm-0" @click="openModalQrCode">
            <font-awesome-icon icon="qrcode" size="3x" class="d-none d-sm-block" />
            <font-awesome-icon icon="qrcode" size="2x" class="d-block d-sm-none" />
          </div>
          <b-modal
            v-if="showModalQrCode"
            id="modal-scan-qr"
            :visible="true"
            size="xl"
            hide-footer
            centered
            @hide="closeModalQrCode"
          >
            <template #modal-title>
              <div>Scanner QR</div>
            </template>
            <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
              <div v-if="isQrScannerLoading" class="loading-indicator">
                <appLoader />
              </div>
              <div v-if="qrScannerPermissionDenied" class="validation-failure text-center">
                <span> Veuillez donner accès à votre caméra !</span>
              </div>
            </qrcode-stream>
          </b-modal>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import meetingPresenceMixin from "@/mixins/meeting-presence";
import { QrcodeStream, QrcodeDropZone } from "vue-qrcode-reader";

export default {
  components: {
    appMandateName: () => import("@/components/b-table-components/MeetingRegisterMandateName"),
    appMandateRepresentant: () =>
      import("@/components/b-table-components/MeetingRegisterMandateRepresentant"),
    QrcodeStream,
    QrcodeDropZone,
  },
  mixins: [meetingPresenceMixin],
  props: {
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    withoutTitle: {
      type: Boolean,
      default: false,
    },
    selectedContact: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      addedByQrCode: null,
      camera: "auto",
      isQrScannerLoading: false,
      showModalQrCode: false,
      qrScannerPermissionDenied: false,
    };
  },
  computed: {
    items() {
      var MandatesRepresentedByThemSelves = this.getPresentMandates(
        this.presenceMandates,
        "physical"
      );
      var MandatesRepresentedByContacts = this.getMandatesRepresentedByContacts(
        this.presenceMandates,
        "physical"
      );
      var MandatesThatLeft = this.getMandatesThatLeft(this.presenceMandates, "physical");

      return [].concat(
        MandatesRepresentedByThemSelves,
        MandatesRepresentedByContacts,
        MandatesThatLeft
      );
    },
    selectedMandate() {
      let mandate = this.$_.find(this.items, mandate => {
        return mandate.is_selected;
      });
      if (mandate) {
        return mandate;
      }
      return {};
    },
  },
  methods: {
    openModalQrCode() {
      this.showModalQrCode = true;
    },
    closeModalQrCode() {
      this.showModalQrCode = false;
    },
    async onInit(promise) {
      this.isQrScannerLoading = true;
      this.qrScannerPermissionDenied = false;
      try {
        await promise;
      } catch (e) {
        console.error(e);
        let errorToString = e.toString();
        let error = errorToString.includes("Permission denied");
        if (error) {
          this.qrScannerPermissionDenied = true;
        }
      } finally {
        this.isQrScannerLoading = false;
      }
    },
    async onDecode(content) {
      this.addedByQrCode = content;
      this.closeModalQrCode();
    },
  },
};
</script>
